const number = (value) => Number(value) || 0;

/**
 * "Radnici – po stavkama" za firme sa ugovorom "više restorana" (telefon i računar): redovi starog taba (rows)
 * posle pretrage (radnik, stavka, sadržaj paketa), sa inicijalima, smenom i podatkom da li je to prvi red radnika.
 * Zahteva nasleđen stari tab more-restaurants/tabs/ReportMealsTabEmployeeItems (rows, formatShift, filters).
 */
export default {
  computed: {
    shownRows() {
      const search = this.toLatin(String(this.filters.search || "")).toLowerCase().trim();
      const rows = this.rows
        .map((row) => ({
          ...row,
          initials: row.worker
            .split(" ")
            .filter(Boolean)
            .map((part) => part.charAt(0))
            .slice(0, 2)
            .join(""),
          shiftNumber: Number(this.formatShift(row.shift)) || null,
          itemText: this.toLatin(row.item || ""),
          comboText: row.combination ? this.toLatin(row.combination) : "",
        }))
        .filter(
          (row) => !search || [row.worker, row.itemText, row.comboText].join(" ").toLowerCase().includes(search)
        );
      return rows.map((row, index) => ({ ...row, showWorker: index === 0 || rows[index - 1].worker !== row.worker }));
    },
    sums() {
      return {
        quantity: this.shownRows.reduce((sum, row) => sum + number(row.quantity), 0),
        amount: this.shownRows.reduce((sum, row) => sum + number(row.amount), 0),
        quantity_payed: this.shownRows.reduce((sum, row) => sum + number(row.quantity_payed), 0),
      };
    },
    workerCount() {
      return new Set(this.shownRows.map((row) => row.worker)).size;
    },
    emptyTitle() {
      return this.filters.search
        ? this.$t("report_mobile.no_results_for", { search: this.filters.search })
        : this.$t("no_employee_report_data");
    },
  },
};
